// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tox .tox-tbtn[title="More..."]:focus,
.tox .tox-tbtn[title="更多..."]:focus {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/Editor/src/index.less"],"names":[],"mappings":"AACI;;EAEI,uBAAA;AAAR","sourcesContent":[".tox .tox-tbtn {\n    &[title=\"More...\"]:focus,\n    &[title=\"更多...\"]:focus {\n        background: transparent;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
